import { Injectable, signal } from '@angular/core';
import { Content, Genus, PreviewContext } from '@xanadu/model';

@Injectable({
    providedIn: 'root'
})
export class PreviewSignal {
    readonly context = signal<PreviewContext | undefined>(undefined);

    genus(genus: Genus): void {
        if (genus?.site) {
            const context = new PreviewContext(genus.site, genus, genus.genusPreviews);
            this.context.set(context);
        }
    }

    content(content: Content): void {
        if (content) {
            const genus = content.parent as Genus;
            if (genus?.site) {
                const context = new PreviewContext(genus.site, content.data, genus.contentPreviews);
                this.context.set(context);
            }
        }
    }
}
